import React from 'react';
import { connect } from 'react-redux';
import UploadField from './UploadField';
import { Header, Container, Divider } from 'semantic-ui-react';

class UploadPictures extends React.Component {
    state = {
        category: 'Patios'
    };

    render() {  
        if ( this.props.auth.isSignedIn) {
            return (
                <Container>
                    <Header as="h3">Upload Pictures</Header>
                    <Divider />
                    <UploadField/>
                </Container>
            );
        } else {
            return (
                <Container>
                    <Header as="h3">Please Login</Header>
                </Container>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pictureData: state.pictureData
    }
}

export default connect(mapStateToProps)(UploadPictures);